import { POLL_TASKS } from "../constants/actionTypes";
import {ROOT_CHANGE } from "../constants/actionTypes";

export const PollTasks = () => ({
  type: POLL_TASKS
});


export const FetchRootData = () => ({
  type: ROOT_CHANGE
});
